import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const sortOptions = [
  { value: "max_population_served", label: "Population served" },
  { value: "nrw_value", label: "NRW value"},
  { value: "network_length", label: "Network length"},
];

const SortOptions = ({ sortBy, currentSortOption }) => (
  <div className="selects-wrapper">
    <div className="selects-wrapper-title">Sort by</div>
    <Select
      classNamePrefix="Select"
      classNames={{ container: () => "Select__container" }}
      onChange={e => sortBy(e)}
      options={sortOptions}
      placeholder="Sort by..."
      value={sortOptions.find(o => o.value === currentSortOption) || null}
      isClearable={false}
      isSearchable={false}
    />
  </div>
);

SortOptions.propTypes = {
  sortBy: PropTypes.func.isRequired,
  currentSortOption: PropTypes.string.isRequired
};

export default SortOptions;
